module.exports = __webpack_public_path__ + "img/logo.2d805c75.svg";